import qs from 'qs';

export function useQuery(query = location.search.slice(1)) {
  return qs.parse(query) as Record<string, string>;
}
